<script setup lang="ts">
import { mdiClockOutline } from '@quasar/extras/mdi-v7';
import { formatTime } from 'src/shared/composables/useTimer/useTimer';
defineProps<{ totalTimeMs: number }>();
</script>
<template>
  <div class="stat-card acc-time">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('TOTAL_USAGE_TIME') }}</div>
      <div class="stat-badge">
        <q-icon
          :name="mdiClockOutline"
          size="22px"
        />
      </div>
    </div>
    <div class="col column justify-center q-mt-sm">
      <div class="stat-value">{{ formatTime(totalTimeMs, 'min') }}</div>
    </div>
  </div>
</template>
